import ImageHelper from "../../../Helpers/ImageHelper";
import ThemePageData from "../../ThemePageData/ThemePageData";

const BusinessThemes = [
  {
    title: "Autono",
    caption: "Technology & Apps",
    image: ImageHelper.WixTheme01,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme01",
    innerPageData: ThemePageData.theme01,
  },
  {
    title: "Autopile",
    caption: "Automotive & Cars",
    image: ImageHelper.WixTheme02,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme02",
    innerPageData: ThemePageData.theme02,
  },
  {
    title: "Boutique Law Firm",
    caption: "Finance & Law",
    image: ImageHelper.WixTheme03,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme03",
    innerPageData: ThemePageData.theme03,
  },
  {
    title: "Bizbud",
    caption: "Consulting & Coaching",
    image: ImageHelper.WixTheme04,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme04",
    innerPageData: ThemePageData.theme04,
  },
  {
    title: "Boutique Law Firm",
    caption: "Finance & Law",
    image: ImageHelper.WixTheme05,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme05",
    innerPageData: ThemePageData.theme05,
  },
  {
    title: "Car Showroom",
    caption: "Automotive & Cars",
    image: ImageHelper.WixTheme06,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme06",
    innerPageData: ThemePageData.theme06,
  },
  {
    title: "Carpenter 2",
    caption: "Services & Maintenance",
    image: ImageHelper.WixTheme07,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme07",
    innerPageData: ThemePageData.theme07,
  },
  {
    title: "Chicken Farm",
    caption: "Farming & Gardening",
    image: ImageHelper.WixTheme08,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme08",
    innerPageData: ThemePageData.theme08,
  },
  {
    title: "Clics",
    caption: "Advertising & Marketing",
    image: ImageHelper.WixTheme09,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme09",
    innerPageData: ThemePageData.theme09,
  },
  {
    title: "Construction Company",
    caption: "Real Estate",
    image: ImageHelper.WixTheme10,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme10",
    innerPageData: ThemePageData.theme10,
  },
  {
    title: "Creative Staffing1",
    caption: "Advertising & Marketing",
    image: ImageHelper.WixTheme11,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme11",
    innerPageData: ThemePageData.theme11,
  },
  {
    title: "Davon",
    caption: "Consulting & Coaching",
    image: ImageHelper.WixTheme12,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme12",
    innerPageData: ThemePageData.theme12,
  },
  {
    title: "Dean and Brooks",
    caption: "Consulting & Coaching",
    image: ImageHelper.WixTheme13,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme13",
    innerPageData: ThemePageData.theme13,
  },
  {
    title: "Digital Advertising",
    caption: "Advertising & Marketing",
    image: ImageHelper.WixTheme14,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme14",
    innerPageData: ThemePageData.theme14,
  },
  {
    title: "Dog Apparel Shop",
    caption: "Pets & Animals",
    image: ImageHelper.WixTheme15,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme15",
    innerPageData: ThemePageData.theme15,
  },
  {
    title: "Dog Food Online Store",
    caption: "Pets & Animals",
    image: ImageHelper.WixTheme16,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme16",
    innerPageData: ThemePageData.theme16,
  },
  {
    title: "Dog Grooming",
    caption: "Pets & Animals",
    image: ImageHelper.WixTheme17,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme17",
    innerPageData: ThemePageData.theme17,
  },
  {
    title: "Dog Walker",
    caption: "Pets & Animals",
    image: ImageHelper.WixTheme18,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme18",
    innerPageData: ThemePageData.theme18,
  },
  {
    title: "Dwell",
    caption: "Real Estate",
    image: ImageHelper.WixTheme19,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme19",
    innerPageData: ThemePageData.theme19,
  },
  {
    title: "Finance Consulting",
    caption: "Finance & Law",
    image: ImageHelper.WixTheme20,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme20",
    innerPageData: ThemePageData.theme20,
  },
  {
    title: "Go Solar",
    caption: "Services & Maintenance",
    image: ImageHelper.WixTheme21,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme21",
    innerPageData: ThemePageData.theme21,
  },
  {
    title: "Health Coach",
    caption: "Consulting & Coaching",
    image: ImageHelper.WixTheme22,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme22",
    innerPageData: ThemePageData.theme22,
  },
  {
    title: "Hillside Industries",
    caption: "Services & Maintenance",
    image: ImageHelper.WixTheme23,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme23",
    innerPageData: ThemePageData.theme23,
  },
  {
    title: "Home Remodeli Editor",
    caption: "Services & Maintenance",
    image: ImageHelper.WixTheme24,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme24",
    innerPageData: ThemePageData.theme24,
  },

  {
    title: "It Services",
    caption: "Technology & Apps",
    image: ImageHelper.WixTheme25,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme25",
    innerPageData: ThemePageData.theme25,
  },
  {
    title: "James Consult Remake",
    caption: "Consulting & Coaching",
    image: ImageHelper.WixTheme26,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme26",
    innerPageData: ThemePageData.theme26,
  },
  {
    title: "Jenny Gilbert",
    caption: "Real Estate",
    image: ImageHelper.WixTheme27,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme27",
    innerPageData: ThemePageData.theme27,
  },
  {
    title: "Lawn Care",
    caption: "Farming & Gardening",
    image: ImageHelper.WixTheme28,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme28",
    innerPageData: ThemePageData.theme28,
  },
  {
    title: "Luxury Real Estate",
    caption: "Real Estate",
    image: ImageHelper.WixTheme29,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme29",
    innerPageData: ThemePageData.theme29,
  },
  {
    title: "Marketing Firm",
    caption: "Advertising & Marketing",
    image: ImageHelper.WixTheme30,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme30",
    innerPageData: ThemePageData.theme30,
  },
  {
    title: "Mechanic",
    caption: "Automotive & Cars",
    image: ImageHelper.WixTheme31,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme31",
    innerPageData: ThemePageData.theme31,
  },
  {
    title: "Pet Care",
    caption: "Pets & Animals",
    image: ImageHelper.WixTheme32,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme32",
    innerPageData: ThemePageData.theme32,
  },
  {
    title: "Pet Supply Store",
    caption: "Pets & Animals",
    image: ImageHelper.WixTheme33,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme33",
    innerPageData: ThemePageData.theme33,
  },
  {
    title: "Plantlife",
    caption: "Services & Maintenance",
    image: ImageHelper.WixTheme34,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme34",
    innerPageData: ThemePageData.theme34,
  },
  {
    title: "Printa",
    caption: "Technology & Apps",
    image: ImageHelper.WixTheme35,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme35",
    innerPageData: ThemePageData.theme35,
  },
  {
    title: "Real Estate Company",
    caption: "Real Estate",
    image: ImageHelper.WixTheme36,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme36",
    innerPageData: ThemePageData.theme36,
  },
  {
    title: "Real Estate Consult",
    caption: "Real Estate",
    image: ImageHelper.WixTheme37,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme37",
    innerPageData: ThemePageData.theme37,
  },
  {
    title: "Real Estate Landing",
    caption: "Real Estate",
    image: ImageHelper.WixTheme38,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme38",
    innerPageData: ThemePageData.theme38,
  },
  {
    title: "Single Property",
    caption: "Real Estate",
    image: ImageHelper.WixTheme39,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme39",
    innerPageData: ThemePageData.theme39,
  },
  {
    title: "Social Media Agency",
    caption: "Technology & Apps",
    image: ImageHelper.WixTheme40,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme40",
    innerPageData: ThemePageData.theme40,
  },
  {
    title: "Success Coach",
    caption: "Consulting & Coaching",
    image: ImageHelper.WixTheme41,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme41",
    innerPageData: ThemePageData.theme41,
  },
  {
    title: "Unite",
    caption: "Technology & Apps",
    image: ImageHelper.WixTheme42,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme42",
    innerPageData: ThemePageData.theme42,
  },
  {
    title: "Vista Io",
    caption: "Advertising & Marketing",
    image: ImageHelper.WixTheme43,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme43",
    innerPageData: ThemePageData.theme43,
  },
  {
    title: "We Du",
    caption: "Technology & Apps",
    image: ImageHelper.WixTheme44,
    fullWebSS: true,
    hasInnerPage: true,
    urlSuffix: "theme44",
    innerPageData: ThemePageData.theme44,
  },
];

export default BusinessThemes;
